import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Award, X } from 'lucide-react';
import { cn } from '../utils';

const AchievementToast = ({ achievement, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  if (!achievement) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 50, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9, transition: { duration: 0.2 } }}
      className="fixed bottom-44 md:bottom-24 left-1/2 -translate-x-1/2 z-[100] w-full max-w-sm px-4"
    >
      <div className="bg-white rounded-3xl shadow-2xl border border-yellow-100 p-1 overflow-hidden">
        <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-[2.5rem] p-4 flex items-center gap-4 relative">
          <div className="w-14 h-14 rounded-2xl bg-yellow-400 flex items-center justify-center text-white shadow-lg shadow-yellow-200 shrink-0">
            <Award size={32} />
          </div>
          
          <div className="flex-1 min-w-0">
            <p className="text-xxs font-bold text-yellow-600 uppercase tracking-[0.2em] mb-0.5">New Achievement</p>
            <h4 className="text-sm font-black text-gray-900 truncate">{achievement.name || 'Level Up!'}</h4>
            <p className="text-xs text-gray-500 font-medium line-clamp-1">{achievement.description || "You've earned a new badge."}</p>
          </div>

          <button 
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={18} />
          </button>

          {/* Sparkles/Particles could be added here for extra juice */}
          <div className="absolute top-2 right-12 pointer-events-none">
            <motion.div 
              animate={{ 
                scale: [1, 1.2, 1],
                opacity: [0.3, 0.6, 0.3],
                rotate: [0, 45, 0]
              }}
              transition={{ repeat: Infinity, duration: 2 }}
              className="text-yellow-400"
            >
              ✨
            </motion.div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default AchievementToast;
